import { useState, useEffect, useCallback } from 'react';
import { axiosApi } from '../../api/setupApi';

function useNisMachineries(year) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNisMachineries = useCallback(async () => {
    if (!year) return;
    setLoading(true);
    setError(null);

    try {
      const { data } = await axiosApi.get(`/nisMachineries/nested/${year}`);
      setData(data);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchNisMachineries();
  }, [fetchNisMachineries]);

  return { data, loading, error, refetch: fetchNisMachineries };
}

export default useNisMachineries;
